import React from 'react';
import PropTypes from 'prop-types';
import { resolve, select } from '@cvent/nucleus-dynamic-css';
import NucleusButton from 'nucleus-core/buttons/Button';
import { resolveTestId } from '@cvent/nucleus-test-automation';

/**
* The basic button widget UI implementation.
*/
const Button = (props) => {
  // Originally, buttons were implemented with rich text editors, but since then
  // they have been updated to be normal textboxes. So we have to allow the text
  // property to come in as rich text or normal plain text. https://jira/browse/FLEX-6581
  let textElement;
  if (props.isRichText) {
    textElement = (
      <span {...resolve(props, 'text')}
        dangerouslySetInnerHTML={{ __html: props.text }} />
    );
  } else {
    textElement = (
      <span {...resolve(props, 'text')}>
        {props.text}
      </span>
    );
  }

  return (
    <div {...resolveTestId(props)} {...resolve(props, 'container')}>
      <div {...resolve(props, 'buttonWrapper')}>
        <NucleusButton {...select(props, 'button')}
          onClick={props.onClick}
          kind={props.kind}
          disabled={props.disabled} >
            {textElement}
        </NucleusButton>
      </div>
      {props.link && props.link.enabled &&
        <div {...resolve(props, 'linkWrapper')}>
          <a {...resolve(props, 'link')} href="#" onClick={props.link.onClick}>{props.link.text}</a>
        </div>}
    </div>
  );
};
Button.displayName = 'Button';
Button.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  kind: PropTypes.string,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    enabled: PropTypes.bool.isRequired
  }),
  disabled: PropTypes.bool,
  isRichText: PropTypes.bool
};

export default Button;



// WEBPACK FOOTER //
// ./~/nucleus-widgets/lib/Button/Button.js